import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import LinkifyWrapper from '../LinkifyWrapper';

const LinkList = ({ items, className }) => (
  <LinkifyWrapper>
    <List bulleted className={clsx('aridhia-link-list', className)}>
      {items.map((item) => (
        <List.Item className="mb-0" key={`link_list_${item}`}>
          {item}
        </List.Item>
      ))}
    </List>
  </LinkifyWrapper>
);

export default LinkList;
